export default "__VITE_ASSET__jOUO7U$6__"